import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../services/api/account.service';
import { ThreadService } from '../../services/api/thread.service';
import { LogService } from '../../services/api/log.service';
// import { MAT_DATE_FORMATS } from '@angular/material/core';
import { DatePipe } from '@angular/common';

import { NotificationService } from '../../services/notification.service';
import { CONSTANTS } from '../../constants';

import * as $ from 'jquery';
// import { MatTableDataSource } from '@angular/material/table';
import { DataService } from '../../services/data.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

export interface PeriodicElement {
  alice_id: number;
  date: string;
  message: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {alice_id: 1123, date: '5-8-21', message:"message 1"},
  {alice_id: 2234, date: '7-8-21', message: "message 2"},
  {alice_id: 3345, date: '11-8-21', message: "message 3"},
];
@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
  providers: [
    // { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class LogsComponent implements OnInit {

  displayedColumns: string[] = ['alice_id', 'date', 'message'];
  // dataSource =new MatTableDataSource(undefined);// ELEMENT_DATA;

  offset = 0;
  count = 20; 
  totalPages = 0;
  totalItems = 0;
  selectedItemPerPage = 0;
  settings: any;
  subCategories = [];
  selSubCat = [];
  selProd: any = {};
  cdata: any;
  isChecked = false;
  isAllChecked = false;
  idx = 0;
  admin: any;
  searchInput:string = "";
  searchParam: string = "";
  pageNumber = 0;
  lastPage: number = 0;
  public innerWidth: any;

  tabInfo: any;
  state: any;
  logs: any;
  logDate: string | null = new Date().toDateString();

  defaultUser = {full_name: "Select", _id: 0 }
  defaultUserStrategy = {display_name: "Select", _id: 0 }
  defaultLType = {display_name: "State", _id: 'state' }
  ltypes = [
    {name: "State", _id: 'state' },
    {name: "Logs", _id: 'log' }
  ]
  users = [this.defaultUser];
  userStrategies = [this.defaultUserStrategy];
  selected_details = {
    user: this.users[0]._id,
    user_strategy: this.userStrategies[0]._id,
    ltype: this.ltypes[0]._id
  }

  // applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   // this.dataSource.filter = filterValue.trim().toLowerCase();
  // }

  constructor(private accountService: AccountService, private dataService: DataService,
    private threadService: ThreadService, private logService: LogService,
    private notificationService: NotificationService) {
      this.logDate = new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd')
      this.state = { detail: {}, short: { rows: [], cols: [] } }
  }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.LOGS});
    this.settings = {
      singleSelection: true,
      text: "",
      enableSearchFilter: false,
      maxHeight: 250,
      labelKey: 'full_name',
      primaryKey: '_id'
    };
    this.tabInfo = {
      'selected': (this.admin == 'true') ? 'detail' : 'short',
      'detailCls': { 'show': 1, 'active': 1},
      'shortCls': { 'show': 0, 'active': 0}
    }

    this.innerWidth = window.innerWidth;
    if(innerWidth <= 700){
      $("#wrapper").removeClass('toggled');
    }else{
      $("#wrapper").removeClass('toggled');
    }
    if(this.admin == 'true'){
      this.listUsers();
    }else {
      this.listUserStrategies();
    }
  }

  listUsers(data = {}) {
    this.accountService.listAccounts().subscribe((response: any) => {
      if (response.response_code == 1000) {
        let users = []
        for (let i = 0; i < response.accounts.length; i++) {
          let acc = response.accounts[i]
          users.push({
            _id: acc._id,
            full_name: acc.user.full_name,
          })
        }
        this.users = users;
        this.selected_details.user = this.users[0]._id;
        this.listUserStrategies();
      }
    });
  }

  loadLogs() {
    this.listLogs();
  }

  listLogs() {
    let data: any;
    if (this.admin == 'true') {
      data = {
        tid: this.selected_details.user_strategy,
        dt: this.logDate,
        dtype: this.selected_details.ltype,
        ltype: this.tabInfo.selected
      }
    } else {
      data = {
        tid: this.selected_details.user_strategy,
        dt: this.logDate,
        dtype: "state",
        ltype: "short"
      }
    }
    this.logService.getLogs(data).subscribe((response: any) => {
      if (response.response_code == 1000) {
        if (this.selected_details.ltype == 'state') {
          this.state = this.state || {}
          if (this.tabInfo.selected == 'short') {
            let columns: any = [
              { id: 'sp', name: 'Strike'},
              { id: 'avg', name: 'Entry'},
              { id: 'xavg', name: 'Exit'},
              { id: 'tgt', name: 'Tgt'},
              { id: 'trailed', name: 'Trailed Count'},
              { id: 'init_sl', name: 'Init SL'},
              { id: 'ct_sl', name: 'SL'},
              { id: 'state', name: 'State'}
            ]
            let short: any = { cols: [], rows: []  };
            let keys = Object.keys(response.state || {});
            let key, obj, row: any, cols_added = false;
            for (let i = 0; i < keys.length; i++) {
              key = keys[i];
              obj = response.state[key];
              row = { '#': key.toUpperCase() }
              for (let j = 0; j < columns.length; j++) {
                if (!cols_added) {
                  short.cols.push(columns[j]['name']);
                }
                if (columns[j]['id'] == 'state') {
                  let states: any = { 'completed': 'Closed', 'sl_hit': 'SL Hit', 'tgt_hit': 'Tgt Hit' }
                  row[columns[j].name] = states[response.state[key][columns[j]['id']]] || '-';
                } else {
                  row[columns[j].name] = response.state[key][columns[j]['id']] || '-';
                }
              }
              cols_added = true;
              short.rows.push(row);
            }
            this.state = { detail: {}, short: short };
          } else {
            let detail: any = {};
            for (let key in response.state) {
              detail = response.state[key];
            }
            this.state = { detail: detail, short: { rows: [], cols: [] } };
          }
          this.logs = [];
        } else {
          this.logs = response.logs || [];
          this.state = {};
        }
      }
    });
  }

  listUserStrategies() {
    let data;
    if(this.admin == 'true'){
       data = {count_per_page:10,page_num:1,acc_id: this.selected_details.user, display_for:'web_main_list'}
    }else {
      data = {count_per_page:10,page_num:1,acc_id: sessionStorage.getItem(CONSTANTS.COOKIE.USER_ID), display_for:'web_main_list'}
    }
    this.threadService.list(data).subscribe((response: any) => {
      if (response.response_code == 1000) {
        let threads = response.threads
        if (threads.length > 0) {
          let userStrategies: any = []
          for (let idx in threads) {
            userStrategies.push(this.toUsRow(threads[idx]))
          }
          this.userStrategies = userStrategies;
          this.selected_details.user_strategy = this.userStrategies[0]._id;
          this.listLogs();
        } else {
          this.userStrategies = [this.defaultUserStrategy];
          this.selected_details.user_strategy = this.userStrategies[0]._id;
        }
      }
    });
  }

  onLTypeChanged() {
    this.listLogs();
  }

  onUserChanged() {
    this.listUserStrategies();
  }

  onUserStrategyChanged() {
    this.listLogs();
  }

  onPageSelected(currentPage: any) {
    // this.listLogs({ page: currentPage});
  }

  search() {
    // this.startDate = new DatePipe('en-US').transform(this.startDate, 'yyyy-MM-dd')
    // this.endDate = new DatePipe('en-US').transform(this.endDate, 'yyyy-MM-dd')
    if(this.searchInput=="")
    {
      this.notificationService.showAlert(CONSTANTS.ERROR, "Please Enter Valid Alice Blue ID.")
      return;
    }
    // if(this.startDate==null)
    // {
    //   this.ns.showAlert(CONSTANTS.ERROR, "Please Enter Start Date.")
    //   return;
    // }
    // if(this.endDate==null)
    // {
    //   this.ns.showAlert(CONSTANTS.ERROR, "Please Enter End Date.")
    //   return;
    // }
    
    this.searchParam = this.searchInput;
    // this.listLogs({ search: this.searchParam, startDate:this.startDate, endDate:this.endDate });
  }

  clear() {
    this.searchInput = "";
    this.searchParam = "";
    // this.startDate = "";
    // this.endDate = "";
    // this.listLogs();
  }

  toUsRow(us: any) {
    return {
      '_id': us['_id'],
      'display_name': us['display_name'],
      'original': us
    }
  }

  prev() {
    if (this.pageNumber >= 1) {
      if (this.pageNumber != 0) {
        this.pageNumber -= 1;
      }
      // this.listLogs({ page: this.pageNumber + 1 });
    }
  }

  next() {
    this.lastPage = this.totalPages - 1;
    if (this.pageNumber <= this.lastPage) {
      if (this.pageNumber != this.lastPage) {
        this.pageNumber += 1;
      }
      // this.listLogs({ page: this.pageNumber + 1 });
    }
  }
  onTabSelected(tab_name: any) {
    this.tabInfo.selected = tab_name
    this.tabInfo.detailCls = { 'show': (tab_name == 'detail') ? 1 : 0, 'active': (tab_name == 'detail') ? 1 : 0 }
    this.tabInfo.shortCls = { 'show': (tab_name == 'detail') ? 0 : 1, 'active': (tab_name == 'detail') ? 0 : 1 }
    this.listLogs()
  }
}
